import React, { useEffect, useState, useCallback } from 'react'
import { getExchangeCons } from '../../actions/dashboard'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../components/Loader'
import Table from '../../components/Table'
import moment from 'moment'
import styles from './styles.module.scss'
import TableSearch from '../../components/TableSearch'

const Exchange = () => {

  const dispatch = useDispatch()
  const { exchange, loading } = useSelector(state => state.dashboard)
  const [filteredData, setFilteredData] = useState(null)
  const [sortState, setSortState] = useState({ key: null, order: null })
  const [openSearchKey, setOpenSearchKey] = useState(null)

  useEffect(() => {
    dispatch(getExchangeCons())
  }, [dispatch])

  const handleFilter = useCallback((result, query) => {
    if (!query) {
      setFilteredData(null)
      return
    }
    setFilteredData(result || [])
  }, [])

  const handleSort = useCallback((sortedData, sortKey, sortOrder) => {
    setSortState({ key: sortOrder ? sortKey : null, order: sortOrder })
  }, [])

  const handleSearchOpen = useCallback((searchKey) => {
    setOpenSearchKey(searchKey)
  }, [])

  // Комбинируем фильтрацию и сортировку
  const dataToRender = React.useMemo(() => {
    let data = filteredData ?? exchange

    // Сортировка первичного массива по алфавиту (если нет активной сортировки)
    if (!sortState.order || !sortState.key) {
      if (data && data.length > 0) {
        data = [...data].sort((a, b) => {
          const aName = String(a?.OrgName || '').toLowerCase().trim()
          const bName = String(b?.OrgName || '').toLowerCase().trim()
          return aName.localeCompare(bName, 'ru', { numeric: true })
        })
      }
    }

    if (sortState.order && sortState.key) {
      const sorted = data && [...data]?.sort((a, b) => {
        const aValue = a?.[sortState.key]
        const bValue = b?.[sortState.key]

        if (aValue === null || aValue === undefined) return 1
        if (bValue === null || bValue === undefined) return -1

        if (typeof aValue === 'number' && typeof bValue === 'number') {
          return sortState.order === 'asc' ? aValue - bValue : bValue - aValue
        }

        const aStr = String(aValue).toLowerCase()
        const bStr = String(bValue).toLowerCase()

        if (sortState.order === 'asc') {
          return aStr.localeCompare(bStr, 'ru', { numeric: true })
        } else {
          return bStr.localeCompare(aStr, 'ru', { numeric: true })
        }
      })
      return sorted
    }

    return data
  }, [filteredData, exchange, sortState])

  if (loading) return <Loader />;

  const isExchangeOverdue = (date) => {
    if (!date) return false
    const mDate = moment(date)
    if (!mDate.isValid()) return false
    return moment().diff(mDate, 'hours') > 24
  }

  const renderLog = (item) => {
    const time =
      item.SyncDate !== null && item.SyncDate !== undefined && moment(item.SyncDate).isValid()
        ? moment(item.SyncDate).format('DD.MM.YYYY HH:mm:ss')
        : ''
    const overdue = isExchangeOverdue(item.SyncDate)

    return (
      <tr key={item.id}>
        <td>{item.OrgName}</td>
        <td
          style={{ textAlign: 'center', width: '170px' }}
          className={overdue ? styles.exchangeOverdue : ''}
        >
          {time}
        </td>
      </tr>
    )
  }

  return (
    <section>
      <Table maxHeight='86vh' minHeight='500px' dataLoaded={!loading && exchange?.length > 0}>
        <thead>
          <tr>
            <th>
              <div className={styles.headerCellWrapper}>
                <div>Наименование</div>
                <div>
                  <TableSearch
                    data={exchange}
                    searchKey="OrgName"
                    onFilter={handleFilter}
                    onSort={handleSort}
                    activeSortKey={sortState.key}
                    activeSortOrder={sortState.order}
                    onSearchOpen={handleSearchOpen}
                    openSearchKey={openSearchKey}
                  />
                </div>
              </div>
            </th>
            <th>
              <div className={styles.headerCellWrapper}>
                <div>Дата обмена</div>
                <div>
                  <TableSearch
                    data={exchange}
                    searchKey="SyncDate"
                    onFilter={handleFilter}
                    onSort={handleSort}
                    activeSortKey={sortState.key}
                    activeSortOrder={sortState.order}
                    onSearchOpen={handleSearchOpen}
                    openSearchKey={openSearchKey}
                  />
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {dataToRender?.map(renderLog)}
        </tbody>
      </Table>
    </section>
  )
}

export default Exchange